// ============================================
// LIGA AJUPAM - Name Normalization Utility
// ============================================
// Utilidad para normalizar y detectar errores en nombres y apellidos

// Diccionario de nombres comunes argentinos con tildes correctas
// (let para permitir actualización desde DB)
let NOMBRES_COMUNES: Record<string, string> = {
  // Nombres masculinos
  'jose': 'José',
  'maria': 'María',
  'juan': 'Juan',
  'carlos': 'Carlos',
  'luis': 'Luis',
  'jorge': 'Jorge',
  'pedro': 'Pedro',
  'miguel': 'Miguel',
  'angel': 'Ángel',
  'francisco': 'Francisco',
  'antonio': 'Antonio',
  'diego': 'Diego',
  'javier': 'Javier',
  'daniel': 'Daniel',
  'alejandro': 'Alejandro',
  'fernando': 'Fernando',
  'ricardo': 'Ricardo',
  'roberto': 'Roberto',
  'martin': 'Martín',
  'raul': 'Raúl',
  'oscar': 'Óscar',
  'ruben': 'Rubén',
  'hector': 'Héctor',
  'victor': 'Víctor',
  'adrian': 'Adrián',
  'fabian': 'Fabián',
  'sebastian': 'Sebastián',
  'nicolas': 'Nicolás',
  'andres': 'Andrés',
  'tomas': 'Tomás',
  'matias': 'Matías',
  'maximiliano': 'Maximiliano',
  'agustin': 'Agustín',
  'german': 'Germán',
  'julian': 'Julián',
  'cristian': 'Cristian',
  'ezequiel': 'Ezequiel',
  'emanuel': 'Emanuel',
  'ignacio': 'Ignacio',
  'ramon': 'Ramón',
  'cesar': 'César',
  
  // Nombres femeninos
  'ana': 'Ana',
  'laura': 'Laura',
  'andrea': 'Andrea',
  'carolina': 'Carolina',
  'gabriela': 'Gabriela',
  'patricia': 'Patricia',
  'monica': 'Mónica',
  'silvia': 'Silvia',
  'claudia': 'Claudia',
  'veronica': 'Verónica',
  'alejandra': 'Alejandra',
  'natalia': 'Natalia',
  'daniela': 'Daniela',
  'marcela': 'Marcela',
  'cecilia': 'Cecilia',
  'valeria': 'Valeria',
  'mariana': 'Mariana',
  'paula': 'Paula',
  'romina': 'Romina',
  'vanesa': 'Vanesa',
  'soledad': 'Soledad',
  'belen': 'Belén',
  'florencia': 'Florencia',
  'victoria': 'Victoria',
  'camila': 'Camila',
  'micaela': 'Micaela',
  'agustina': 'Agustina',
  'lucia': 'Lucía',
  'sofia': 'Sofía',
  'ines': 'Inés',
};

// Groserías y palabras obscenas argentinas
// (let para permitir actualización desde DB)
let GROSERÍAS_ARGENTINAS = [
  'boludo', 'pelotudo', 'pija', 'culo', 'pene', 'concha', 'verga',
  'puto', 'puta', 'carajo', 'mierda', 'cagada', 'forro', 'choto',
  'sorete', 'trola', 'garca', 'gil', 'tarado', 'salame', 'mogolico',
  'pelotuda', 'boluda', 'turro', 'chorra', 'hdp', 'hdrmp', 'hijo de puta',
  // Variaciones con letras sustituidas
  'p3lotudo', 'b0ludo', 'p1ja', 'c0ncha', 'p3ne', 'v3rga',
  'pu70', 'p.u.t.o', 'f0rro', 's0rete', 'ch0to',
];

// Apodos y diminutivos comunes argentinos
// (let para permitir actualización desde DB)
let APODOS_COMUNES = [
  'el', 'la', 'los', 'las', // Artículos
  'flaco', 'gorda', 'negro', 'ruso', 'chino', 'turco', 'gringo',
  'mono', 'tano', 'wacho', 'pibe', 'gordo', 'chiqui', 'bebe',
  'loco', 'toto', 'coco', 'pepe', 'kike', 'tincho', 'mati',
  'seba', 'nico', 'facu', 'caro', 'sofi', 'guille', 'fede',
  'chueco', 'flaca', 'negra', 'rubia', 'morocho', 'pelado',
];

// Correcciones de errores de tipeo comunes en nombres argentinos
// (let para permitir actualización desde DB)
let TYPO_CORRECTIONS: Record<string, string> = {
  'jhon': 'John',
  'jhonatan': 'Jonathan',
  'yaninna': 'Yanina',
  'florenciia': 'Florencia',
  'agustiina': 'Agustina',
  'maximiiliano': 'Maximiliano',
  'emmanuuel': 'Emanuel',
  'cristhian': 'Cristian',
  'ezequiiel': 'Ezequiel',
  'jhuan': 'Juan',
  'jonatam': 'Jonathan',
  'esteeban': 'Esteban',
  'gabirel': 'Gabriel',
  'miquuel': 'Miguel',
  'gabriiel': 'Gabriel',
};

// Apellidos comunes argentinos (para detectar inversión)
// (let para permitir actualización desde DB)
let APELLIDOS_COMUNES = [
  'gonzalez', 'rodriguez', 'garcia', 'fernandez', 'lopez', 'martinez',
  'sanchez', 'perez', 'gomez', 'martin', 'jimenez', 'ruiz', 'hernandez',
  'diaz', 'moreno', 'alvarez', 'muñoz', 'romero', 'alonso', 'gutierrez',
  'navarro', 'torres', 'dominguez', 'vazquez', 'ramos', 'gil', 'ramirez',
  'serrano', 'blanco', 'suarez', 'molina', 'morales', 'ortega', 'delgado',
  'castro', 'ortiz', 'rubio', 'marin', 'sanz', 'iglesias', 'nuñez',
  'medina', 'garrido', 'santos', 'castillo', 'cortes', 'lozano', 'mendez',
  'guerrero', 'cruz', 'prieto', 'flores', 'herrera', 'peña', 'leon',
  'marquez', 'cabrera', 'gallego', 'calvo', 'vidal', 'campos', 'reyes',
  'vega', 'fuentes', 'carrasco', 'diez', 'aguilar', 'caballero', 'nieto',
  'santana', 'vargas', 'gimenez', 'montero', 'ibañez', 'pascual', 'ferrer',
  'duran', 'santiago', 'benitez', 'mora', 'vicente', 'arias', 'carmona',
  'cano', 'mendoza', 'roman', 'vila', 'rojas', 'soto', 'bravo', 'silva',
  'mendez', 'hidalgo', 'lorenzo', 'parra', 'saez', 'moya', 'esteban',
];

export interface NameValidationResult {
  isValid: boolean;
  normalized: string;
  suggestions: string[];
  warnings: string[];
  errors: string[];
}

/**
 * Elimina espacios múltiples y espacios al inicio/final
 */
export const trimSpaces = (text: string): string => {
  return text.trim().replace(/\s+/g, ' ');
};

/**
 * Capitaliza correctamente un nombre (primera letra mayúscula, resto minúscula)
 */
export const capitalizeWord = (word: string): string => {
  if (!word) return '';
  
  // Casos especiales: preposiciones y artículos en minúscula
  const lowercase = ['de', 'del', 'la', 'las', 'los', 'y', 'e'];
  if (lowercase.includes(word.toLowerCase())) {
    return word.toLowerCase();
  }
  
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

/**
 * Capitaliza un nombre completo correctamente
 */
export const capitalizeName = (name: string): string => {
  return trimSpaces(name)
    .split(' ')
    .map(capitalizeWord)
    .join(' ');
};

/**
 * Detecta si el texto está todo en mayúsculas
 */
export const isAllUppercase = (text: string): boolean => {
  const letters = text.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ]/g, '');
  return letters.length > 0 && letters === letters.toUpperCase();
};

/**
 * Detecta si el texto está todo en minúsculas
 */
export const isAllLowercase = (text: string): boolean => {
  const letters = text.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ]/g, '');
  return letters.length > 0 && letters === letters.toLowerCase();
};

/**
 * Normaliza tildes en nombres usando el diccionario
 */
export const normalizeTildes = (name: string): string => {
  const words = trimSpaces(name).split(' ');
  
  return words.map(word => {
    const lowerWord = word.toLowerCase();
    
    // Buscar en diccionario de nombres
    if (NOMBRES_COMUNES[lowerWord]) {
      return NOMBRES_COMUNES[lowerWord];
    }
    
    // Si no está en el diccionario, capitalizar normalmente
    return capitalizeWord(word);
  }).join(' ');
};

/**
 * Detecta si posiblemente el nombre y apellido están invertidos
 */
export const detectInversion = (fullName: string): { isInverted: boolean; suggestion?: string } => {
  // ✅ FIX: Eliminar caracteres especiales (incluye comas) ANTES de split
  const cleanWords = trimSpaces(fullName)
    .replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s'-]/g, '') // Eliminar comas, números, puntos, etc.
    .toLowerCase()
    .split(' ')
    .filter(w => w.length > 0); // Eliminar palabras vacías

  if (cleanWords.length < 2) {
    return { isInverted: false };
  }

  // Verificar si la primera palabra es un apellido común
  const firstWord = cleanWords[0];
  const isFirstWordSurname = APELLIDOS_COMUNES.includes(firstWord);

  // Verificar si la segunda palabra es un nombre común
  const secondWord = cleanWords[1];
  const isSecondWordName = NOMBRES_COMUNES[secondWord] !== undefined;

  // Si la primera es apellido y la segunda es nombre, probablemente está invertido
  if (isFirstWordSurname && isSecondWordName) {
    // Sugerir inversión
    const inverted = cleanWords.slice(1).concat(cleanWords[0]).join(' ');
    return {
      isInverted: true,
      suggestion: capitalizeName(inverted)
    };
  }

  return { isInverted: false };
};

/**
 * Detecta caracteres especiales no válidos
 */
export const hasInvalidCharacters = (text: string): boolean => {
  // Permitir: letras, espacios, tildes, ñ, apóstrofes, guiones
  const validPattern = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s'-]+$/;
  return !validPattern.test(text);
};

/**
 * Detecta si el nombre contiene groserías o palabras obscenas
 */
export const hasObscenity = (name: string): boolean => {
  const normalized = name.toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Quitar tildes
    .replace(/[^a-z\s]/g, ''); // Solo letras y espacios

  return GROSERÍAS_ARGENTINAS.some(groseria =>
    normalized.includes(groseria.toLowerCase())
  );
};

/**
 * Detecta si el nombre contiene siglas o abreviaturas
 */
export const hasAbbreviations = (name: string): boolean => {
  // Detecta:
  // - J. Pablo (punto después de inicial)
  // - Gerardo M. Gil (inicial en medio con punto)
  // - Solo iniciales sueltas de 1 letra (ej: "J P" o "M" solo)
  // NO bloquea apellidos cortos como Gil, Rey, Paz, Sol (2-3 letras)
  const SIGLAS_PATTERN = /\b[A-Z]\.|(?:^|\s)[A-Z](?:\s|$)/g;
  return SIGLAS_PATTERN.test(name);
};

/**
 * Detecta las abreviaturas presentes en el nombre
 */
export const detectAbbreviations = (name: string): string[] => {
  const SIGLAS_PATTERN = /\b[A-Z]\.|(?:^|\s)[A-Z](?:\s|$)/g;
  const matches = name.match(SIGLAS_PATTERN);
  return matches ? matches.map(m => m.trim()) : [];
};

/**
 * Detecta si el nombre contiene apodos o diminutivos
 */
export const hasNickname = (name: string): boolean => {
  const words = name.toLowerCase().split(/\s+/);
  return words.some(word => APODOS_COMUNES.includes(word));
};

/**
 * Corrige errores de tipeo comunes en nombres
 */
export const correctTypos = (name: string): string => {
  const words = trimSpaces(name).split(' ');
  const corrected = words.map(word => {
    const lowerWord = word.toLowerCase();
    if (TYPO_CORRECTIONS[lowerWord]) {
      return TYPO_CORRECTIONS[lowerWord];
    }
    return word;
  });
  return corrected.join(' ');
};

/**
 * Valida y normaliza un nombre completo
 */
export const validateAndNormalizeName = (fullName: string): NameValidationResult => {
  const result: NameValidationResult = {
    isValid: true,
    normalized: fullName,
    suggestions: [],
    warnings: [],
    errors: []
  };

  // 1. Verificar que no esté vacío
  if (!fullName || !fullName.trim()) {
    result.isValid = false;
    result.errors.push('El nombre no puede estar vacío');
    return result;
  }

  // 2. Eliminar espacios múltiples
  let normalized = trimSpaces(fullName);

  // 3. Detectar y limpiar caracteres inválidos (números, comas, puntos, paréntesis, asteriscos, etc.)
  if (hasInvalidCharacters(normalized)) {
    result.isValid = false;
    result.errors.push('El nombre contiene caracteres no válidos (números, comas, puntos u otros símbolos especiales)');
    // ✅ LIMPIAR INMEDIATAMENTE para que las validaciones posteriores trabajen con texto limpio
    normalized = normalized.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s'-]/g, '');
    // Eliminar espacios múltiples que puedan haber quedado después de limpiar
    normalized = trimSpaces(normalized);
  }

  // 4. NUEVA VALIDACIÓN: Detectar groserías (BLOQUEO CRÍTICO)
  if (hasObscenity(normalized)) {
    result.isValid = false;
    result.errors.push('El nombre contiene palabras inapropiadas. Por favor, usa tu nombre legal completo.');
    return result;
  }

  // 5. NUEVA VALIDACIÓN: Detectar siglas/abreviaturas (BLOQUEO CRÍTICO)
  if (hasAbbreviations(normalized)) {
    const abbrevs = detectAbbreviations(normalized);
    result.isValid = false;
    result.errors.push(`No se permiten iniciales o siglas: ${abbrevs.join(', ')}. Escribe tu nombre completo.`);
    return result;
  }

  // 6. NUEVA VALIDACIÓN: Detectar apodos (WARNING, no bloquea)
  if (hasNickname(normalized)) {
    result.warnings.push('El nombre parece contener un apodo o diminutivo. Por favor, usa tu nombre legal completo.');
  }

  // 7. NUEVA CORRECCIÓN: Corregir errores de tipeo comunes
  const withTyposFixed = correctTypos(normalized);
  if (withTyposFixed !== normalized) {
    result.suggestions.push(`¿Quisiste decir "${capitalizeName(withTyposFixed)}"?`);
    normalized = withTyposFixed;
  }

  // 8. Detectar si está todo en mayúsculas
  if (isAllUppercase(normalized)) {
    result.warnings.push('El nombre está todo en mayúsculas. Se recomienda usar mayúsculas solo en las iniciales.');
    normalized = capitalizeName(normalized);
    result.suggestions.push(`Sugerencia: "${normalized}"`);
  }

  // 9. Detectar si está todo en minúsculas
  if (isAllLowercase(fullName)) {
    result.warnings.push('El nombre está todo en minúsculas. Se recomienda usar mayúsculas en las iniciales.');
    normalized = capitalizeName(normalized);
    result.suggestions.push(`Sugerencia: "${normalized}"`);
  }

  // 10. Normalizar tildes
  const withTildes = normalizeTildes(normalized);
  if (withTildes !== normalized) {
    result.warnings.push('Se detectaron posibles errores en las tildes');
    result.suggestions.push(`Sugerencia: "${withTildes}"`);
    normalized = withTildes;
  }

  // 11. Detectar posible inversión nombre/apellido
  const inversionCheck = detectInversion(normalized);
  if (inversionCheck.isInverted && inversionCheck.suggestion) {
    result.warnings.push('Posible inversión de nombre y apellido');
    result.suggestions.push(`¿Es "${inversionCheck.suggestion}" en lugar de "${normalized}"?`);
  }

  // 12. Verificar que tenga al menos 2 palabras (nombre y apellido)
  // v6.11.46 — pasó de warning a ERROR. Como warning no bloqueaba nada: el copy
  // decía "Se recomienda", `isValid` seguía en true y `errors` vacío, así que en
  // los formularios con strict={true} (que permite warnings) pasaba derecho. Así
  // se inscribió un jugador de la 5ta con full_name = "Javier " y nada más.
  const words = normalized.split(' ').filter(w => w.length > 0);
  if (words.length < 2) {
    result.isValid = false;
    result.errors.push('Ingresá tu nombre y apellido completos');
  }

  result.normalized = normalized;

  return result;
};

/**
 * Normaliza automáticamente un nombre sin mostrar advertencias
 * (para uso en formularios con auto-corrección)
 */
export const autoNormalizeName = (fullName: string): string => {
  if (!fullName || !fullName.trim()) return '';

  let normalized = trimSpaces(fullName);

  // Eliminar caracteres inválidos
  normalized = normalized.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s'-]/g, '');

  // Capitalizar
  normalized = capitalizeName(normalized);

  // Normalizar tildes
  normalized = normalizeTildes(normalized);

  return normalized;
};

// ============================================
// CARGA DE DICCIONARIOS DESDE BASE DE DATOS
// ============================================

interface DictionaryCache {
  timestamp: number;
  obscenities: string[];
  surnames: string[];
  firstnames: Record<string, string>;
  nicknames: string[];
  typos: Record<string, string>;
}

const CACHE_KEY = 'name_dictionaries_cache_v1';
const CACHE_TTL = 5 * 60 * 1000; // 5 minutos

/**
 * Carga los diccionarios desde la base de datos con caché en localStorage
 * @param forceRefresh Si es true, ignora el caché y recarga desde DB
 */
export const loadDictionariesFromDB = async (forceRefresh = false): Promise<void> => {
  // 1. Verificar caché (solo si no forzamos refresh)
  if (!forceRefresh) {
    try {
      const cached = localStorage.getItem(CACHE_KEY);
      if (cached) {
        const data: DictionaryCache = JSON.parse(cached);
        if (Date.now() - data.timestamp < CACHE_TTL) {
          // Caché válido, actualizar variables globales
          GROSERÍAS_ARGENTINAS = data.obscenities;
          APELLIDOS_COMUNES = data.surnames;
          NOMBRES_COMUNES = data.firstnames;
          APODOS_COMUNES = data.nicknames;
          TYPO_CORRECTIONS = data.typos;
          console.log('✅ Diccionarios cargados desde caché local');
          return;
        }
      }
    } catch (error) {
      console.warn('Error al leer caché de diccionarios:', error);
    }
  }

  // 2. Fetch desde DB
  try {
    // Importar supabase dinámicamente para evitar dependencia circular
    const { supabase } = await import('../services/api/client');

    const { data, error } = await supabase
      .from('name_validation_dictionaries')
      .select('dictionary_type, word, correction, is_active')
      .eq('is_active', true);

    if (error) throw error;

    if (!data || data.length === 0) {
      console.warn('⚠️ No se encontraron diccionarios en DB, usando hardcodeados');
      return;
    }

    // 3. Agrupar por tipo
    const obscenities: string[] = [];
    const surnames: string[] = [];
    const firstnames: Record<string, string> = {};
    const nicknames: string[] = [];
    const typos: Record<string, string> = {};

    for (const row of data) {
      switch (row.dictionary_type) {
        case 'OBSCENITY':
          obscenities.push(row.word);
          break;
        case 'SURNAME':
          surnames.push(row.word);
          break;
        case 'FIRSTNAME':
          if (row.correction) {
            firstnames[row.word] = row.correction;
          }
          break;
        case 'NICKNAME':
          nicknames.push(row.word);
          break;
        case 'TYPO':
          if (row.correction) {
            typos[row.word] = row.correction;
          }
          break;
      }
    }

    // 4. Guardar en caché
    const cacheData: DictionaryCache = {
      timestamp: Date.now(),
      obscenities,
      surnames,
      firstnames,
      nicknames,
      typos,
    };

    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
    } catch (error) {
      console.warn('Error al guardar caché de diccionarios:', error);
    }

    // 5. Actualizar variables globales
    GROSERÍAS_ARGENTINAS = obscenities;
    APELLIDOS_COMUNES = surnames;
    NOMBRES_COMUNES = firstnames;
    APODOS_COMUNES = nicknames;
    TYPO_CORRECTIONS = typos;

    console.log('✅ Diccionarios cargados desde DB:', {
      obscenities: obscenities.length,
      surnames: surnames.length,
      firstnames: Object.keys(firstnames).length,
      nicknames: nicknames.length,
      typos: Object.keys(typos).length,
    });
  } catch (error) {
    console.warn('⚠️ Error al cargar diccionarios desde DB, usando hardcodeados:', error);
    // Mantener diccionarios hardcodeados por defecto (ya inicializados)
  }
};

/**
 * Invalida el caché de diccionarios (útil para admin después de editar)
 */
export const invalidateDictionariesCache = (): void => {
  localStorage.removeItem(CACHE_KEY);
  console.log('🗑️ Caché de diccionarios invalidado');
};
